
// Copied from `logistics` project

import Moment from 'moment';

function exportData(data, name = 'export-data', clickEvent) {
  if (clickEvent) {
    clickEvent.preventDefault();
  }

  const a = document.createElement('a');
  const file = new Blob([JSON.stringify(data)], {
    type: 'text/plain'
  });
  a.href = URL.createObjectURL(file);
  a.download = `${name}-${Moment().format('YYYY_DD_MMM_HH_mm_ss')}.json`;
  a.click();
}




function exportReport(data, name = 'report', clickEvent) {
  if (clickEvent) {
    clickEvent.preventDefault();
  }

  const a = document.createElement('a');
  const arr = new Uint8Array(data);

  const file = new Blob([arr], { type: 'application/pdf' });
  a.href = URL.createObjectURL(file);
  a.download = `${name}-${Moment().format('YYYY_DD_MMM_HH_mm_ss')}.pdf`;
  a.click();
}


export { exportData, exportReport }